import { render } from "./product-form.vue?vue&type=template&id=e7539a94"
import script from "./product-form.vue?vue&type=script&lang=js"
export * from "./product-form.vue?vue&type=script&lang=js"

import "./product-form.vue?vue&type=style&index=0&id=e7539a94&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__